import { createReducer, on } from '@ngrx/store';
import { initialLoggedInUserState, LoggedInUserState } from './logged-in-user.state';
import { LoggedInUserActions } from './logged-in-user.actions';

export const loggedInUserReducer = createReducer<LoggedInUserState>(
  initialLoggedInUserState,
  on(LoggedInUserActions.loadUserSuccess, (state, { user }) => {
    return { ...state, user: user, error: undefined };
  }),
  on(LoggedInUserActions.loadUserError, (state, { error }) => {
    return { ...state, user: undefined, error: error };
  })
);
